import * as React from 'react'

import { action, makeObservable, observable } from 'mobx'
import { observer } from 'mobx-react'

import { NOOP } from '../../utils/noop'

interface IActionBarInput {
  value: string
  onChange: (evt: any) => any
  placeholder?: string
  className?: string
  onKeyPress?: (evt: React.KeyboardEvent<HTMLTextAreaElement>) => void
  maxHeight?: number
}

@observer
export default class ActionBarInput extends React.Component<IActionBarInput> {
  public static defaultProps = {
    className: 'slack-bar-input mb10 no-resize full-width',
    onKeyPress: NOOP,
  }
  @observable private isFocused: boolean = false

  public textarea: HTMLTextAreaElement

  public constructor(props: IActionBarInput) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const { value, placeholder, onChange, onKeyPress } = this.props

    return (
      <textarea
        rows={1}
        onFocus={() => (this.isFocused = true)}
        onBlur={() => (this.isFocused = false)}
        ref={this.setInputRef}
        className={this.props.className}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        onKeyPress={onKeyPress}
      />
    )
  }

  public componentDidUpdate(prevProps: IActionBarInput) {
    const { value } = this.props

    if (!this.textarea) {
      return
    }

    if (!value) {
      this.textarea.style.height = 'auto'
    } else if (value !== prevProps.value) {
      this.autoResize()
    }
  }

  private autoResize = () => {
    const { maxHeight } = this.props

    this.textarea.style.height = 'auto'

    const borderHeight = this.textarea.offsetHeight - this.textarea.clientHeight
    const contentHeight = this.textarea.scrollHeight + borderHeight
    const height = maxHeight
      ? Math.min(contentHeight, maxHeight)
      : contentHeight

    this.textarea.style.height = `${height}px`
  }

  @action.bound
  private setInputRef(ref) {
    this.textarea = ref
  }
}
